export default class ScrollCall {

    /**
     * Namespace
     * @return {string}
     */
    static _namespace() {
        return "nls-";
    }


    ////////////////////
    // Events
    ////////////////////
    /**
     * Receive events to set
     * @param {string} : event name | {function} : callback
     */
    static on(event, callback) {
        ScrollCall._subscribeEvents(event, callback);
    }

    /**
     * Receive events to kill
    * @param {string} : event name | {function} : callback
     */
    static off(event, callback) {
        ScrollCall._unsubcribeEvents(event, callback);
    }


    ////////////////////
    // Events binding
    ////////////////////
    /**
     * Subscribe events
     * @param {string} : event name | {function} : callback
     */
    static _subscribeEvents(event, func) {

        if (!ScrollCall.listeners) {
            ScrollCall.listeners = {}
        }
        
        if (!ScrollCall.listeners[event]) {
            ScrollCall.listeners[event] = [];
        }

        const list = ScrollCall.listeners[event];
        list.push(func);

        if (list.length === 1) {
            document.addEventListener(
                ScrollCall._namespace() + event,
                ScrollCall.checkEvent,
                false
            );
        }
    }

    /**
     * Unsubscribe events
     * @param {string} : event name | {function} : callback
     */
    static _unsubcribeEvents(event, func) {
        if (!ScrollCall.listeners[event]) return;

        const list = ScrollCall.listeners[event];
        const index = list.indexOf(func);

        if (index < 0) return;

        list.splice(index, 1);

        if (list.length === 0) {
            document.removeEventListener(
                ScrollCall._namespace() + event,
                ScrollCall.checkEvent,
                false
            );
        }
    }


    ////////////////////
    // Apply event callback
    ////////////////////
    /**
     * Check events
     * @param {string} : event name
     */
    static checkEvent(event) {
        const name = event.type.replace(ScrollCall._namespace(), "");
        const list = ScrollCall.listeners[name];

        if (!list || list.length === 0) return;

        list.forEach((func) => {
            switch (name) {
                case "call":
                    return func(
                        ScrollCall.callValue,
                        ScrollCall.callWay,
                        ScrollCall.callObj
                    );
                default:
                    return func();
            }
        });
    }

    ////////////////////
    // Dispatch custom event
    ////////////////////
    /**
     * Dispatch custom event
     * @param {string} : data-nls-call | {string} enter/exit | {IntersectionObserverEntry}
     */
    static dispatch(call, way, obj) {
        ScrollCall.callWay = way;
        ScrollCall.callValue = call.split(",").map((item) => item.trim());
        ScrollCall.callObj = obj;
        
        if (ScrollCall.callValue.length == 1)
            ScrollCall.callValue = ScrollCall.callValue[0];
        
        const callEvent = new Event(ScrollCall._namespace() + "call");
        document.dispatchEvent(callEvent);
    }
}
